import { render } from "./CommentsList.vue?vue&type=template&id=bb48f796&ts=true"
import script from "./CommentsList.vue?vue&type=script&lang=ts"
export * from "./CommentsList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__